import React from "react";

interface EnvironmentBannerProps {
  environment?: string;
}

const EnvironmentBanner: React.FC<EnvironmentBannerProps> = ({ environment }) => {
  // Don't show banner for production
  if (!environment || environment === "prod") {
    return null;
  }

  // Determine banner style based on environment
  const getBannerStyle = () => {
    switch (environment.toLowerCase()) {
      case "dev":
      case "development":
        return {
          backgroundColor: "#dc2626", // red-600
          color: "white",
          text: "You are on the DEV Environment",
        };
      case "staging":
        return {
          backgroundColor: "#d97706", // amber-600
          color: "white",
          text: "You are on the STAGING Environment",
        };
      default:
        return {
          backgroundColor: "#6b7280", // gray-500
          color: "white",
          text: `You are on the ${environment.toUpperCase()} Environment`,
        };
    }
  };

  const bannerStyle = getBannerStyle();

  return (
    <div
      className="w-full py-2 px-4 text-center font-medium text-sm"
      style={{
        backgroundColor: bannerStyle.backgroundColor,
        color: bannerStyle.color,
      }}
    >
      {bannerStyle.text}
    </div>
  );
};

export default EnvironmentBanner;
